// extracted by mini-css-extract-plugin
export default {"packageMain":"PurchaseFlow_packageMain__v5umu","packages":"PurchaseFlow_packages__VVuHi","pageState":"PurchaseFlow_pageState__ByQmx"};